import { WifiOff } from 'lucide-react'
import { useEffect, useState } from 'react'

/**
 * Fixed banner just under the top bar. Listens to `online` / `offline` window
 * events so the UI reflects connectivity without polling.
 */
export function OfflineBanner() {
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' && !navigator.onLine)

  useEffect(() => {
    const on = () => setOffline(false)
    const off = () => setOffline(true)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    return () => {
      window.removeEventListener('online', on)
      window.removeEventListener('offline', off)
    }
  }, [])

  if (!offline) return null
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-14 z-40 flex items-center justify-center gap-2 bg-warning-tint px-4 py-2 text-sm text-warning-text"
    >
      <WifiOff className="h-4 w-4" />
      You appear to be offline. Some features may be unavailable.
    </div>
  )
}
